var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" "),(!_vm.hideButton)?_c('div',{staticClass:"more",on:{"click":_vm.toMore}},[_vm._v(" "+_vm._s(_vm.buttonText)+"> ")]):_vm._e()]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }